import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaClock,
  FaUtensils,
  FaTruck,
  FaShoppingBag,
} from "react-icons/fa";

import "./ProviderInfoCard.css";

export default function ProviderInfoCard({
  provider,
}) {
  if (!provider) return null;

  return (
    <div className="provider-info-card">

      <div className="provider-info-grid">

        <div className="provider-info-item">
          <FaClock className="provider-info-icon" />

          <div>
            <h4>Status</h4>

            <p
              className={
                provider.isOpen
                  ? "status-open"
                  : "status-closed"
              }
            >
              {provider.isOpen
                ? "Open Now"
                : "Closed"}
            </p>
          </div>
        </div>

        <div className="provider-info-item">
          <FaTruck className="provider-info-icon" />

          <div>
            <h4>Delivery Radius</h4>

            <p>
              {provider.deliveryRadius || 5} km
            </p>
          </div>
        </div>

        <div className="provider-info-item">
          <FaShoppingBag className="provider-info-icon" />

          <div>
            <h4>Minimum Order</h4>

            <p>
              ₹
              {provider.minimumOrder || 0}
            </p>
          </div>
        </div>

        <div className="provider-info-item">
          <FaUtensils className="provider-info-icon" />

          <div>
            <h4>Business Type</h4>

            <p>
              {provider.providerType}
            </p>
          </div>
        </div>

        <div className="provider-info-item">
          <FaMapMarkerAlt className="provider-info-icon" />

          <div>
            <h4>Address</h4>

            <p>
              {provider.address?.area},{" "}
              {provider.address?.city}
            </p>
          </div>
        </div>

        <div className="provider-info-item">
          <FaPhoneAlt className="provider-info-icon" />

          <div>
            <h4>Contact</h4>

            <p>
              {provider.phone ||
                "Not Available"}
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}